module.exports = __webpack_public_path__ + "img/logo.41741a15.png";